export default __webpack_public_path__ + "static/media/right-arrow.037db56a.svg";